/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UnlinkEMARequestBody,
  UnlinkEMARequestBody$Outbound,
  UnlinkEMARequestBody$outboundSchema,
} from "../components/unlinkemarequestbody.js";

export type UnlinkEMASecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UnlinkEMASecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UnlinkEMASecurity = {
  option1?: UnlinkEMASecurityOption1 | undefined;
  option2?: UnlinkEMASecurityOption2 | undefined;
};

export type UnlinkEMARequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  unlinkEMARequestBody: UnlinkEMARequestBody;
};

/** @internal */
export type UnlinkEMASecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UnlinkEMASecurityOption1$outboundSchema: z.ZodMiniType<
  UnlinkEMASecurityOption1$Outbound,
  UnlinkEMASecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function unlinkEMASecurityOption1ToJSON(
  unlinkEMASecurityOption1: UnlinkEMASecurityOption1,
): string {
  return JSON.stringify(
    UnlinkEMASecurityOption1$outboundSchema.parse(unlinkEMASecurityOption1),
  );
}

/** @internal */
export type UnlinkEMASecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UnlinkEMASecurityOption2$outboundSchema: z.ZodMiniType<
  UnlinkEMASecurityOption2$Outbound,
  UnlinkEMASecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function unlinkEMASecurityOption2ToJSON(
  unlinkEMASecurityOption2: UnlinkEMASecurityOption2,
): string {
  return JSON.stringify(
    UnlinkEMASecurityOption2$outboundSchema.parse(unlinkEMASecurityOption2),
  );
}

/** @internal */
export type UnlinkEMASecurity$Outbound = {
  Option1?: UnlinkEMASecurityOption1$Outbound | undefined;
  Option2?: UnlinkEMASecurityOption2$Outbound | undefined;
};

/** @internal */
export const UnlinkEMASecurity$outboundSchema: z.ZodMiniType<
  UnlinkEMASecurity$Outbound,
  UnlinkEMASecurity
> = z.pipe(
  z.object({
    option1: z.optional(z.lazy(() => UnlinkEMASecurityOption1$outboundSchema)),
    option2: z.optional(z.lazy(() => UnlinkEMASecurityOption2$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function unlinkEMASecurityToJSON(
  unlinkEMASecurity: UnlinkEMASecurity,
): string {
  return JSON.stringify(
    UnlinkEMASecurity$outboundSchema.parse(unlinkEMASecurity),
  );
}

/** @internal */
export type UnlinkEMARequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UnlinkEMARequestBody: UnlinkEMARequestBody$Outbound;
};

/** @internal */
export const UnlinkEMARequest$outboundSchema: z.ZodMiniType<
  UnlinkEMARequest$Outbound,
  UnlinkEMARequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    unlinkEMARequestBody: UnlinkEMARequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      unlinkEMARequestBody: "UnlinkEMARequestBody",
    });
  }),
);

export function unlinkEMARequestToJSON(
  unlinkEMARequest: UnlinkEMARequest,
): string {
  return JSON.stringify(
    UnlinkEMARequest$outboundSchema.parse(unlinkEMARequest),
  );
}
